import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ActionMenuItem, ModalComponent, ModalDismissAction, ModalStyle } from '@doka-shared/common'
import { Plan } from '../models/plan'
import { EfpExportService } from '../services/share/efp-export.service'
import { PlanRepository } from '../repositories/plan.repository'
import { Translation } from '../services/translation.service'
import { ModalController } from '@ionic/angular'
import { Router } from '@angular/router'

@Component({
  selector: 'efp-plan-actions-menu',
  templateUrl: './plan-actions-menu.component.html',
})
export class PlanActionsMenuComponent implements OnInit {
  @Input() plan!: Plan
  @Output() readonly planDeleted = new EventEmitter()
  public menuButtons: ActionMenuItem[] = []

  constructor(
    protected readonly router: Router,
    protected readonly modalCtrl: ModalController,
    protected readonly translate: Translation,
    protected readonly planRepository: PlanRepository,
    protected readonly efpExportService: EfpExportService
  ) {}

  ngOnInit(): void {
    this.getActionMenuOptions()
  }

  public getActionMenuOptions(): void {
    this.menuButtons.push(
      {
        text: this.translate.translate('PLAN.EDIT_PLAN'),
        icon: 'edit',
        handler: async () => {
          await this.router.navigate(['plansettings', this.plan.id], {
            queryParams: { backUrl: this.router.url.split('?')[0] },
          })
        },
      },
      {
        text: this.translate.translate('PLAN.SHARE'),
        disabled: this.efpExportService.isLoading,
        icon: 'share',
        handler: () => {
          void this.share()
        },
      },
      {
        text: this.translate.translate('GENERAL.DELETE'),
        alertStyle: true,
        icon: 'delete',
        handler: () => {
          void this.deletePlan(this.plan)
        },
      }
    )
  }

  public async deletePlan(plan: Plan): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: ModalComponent,
      backdropDismiss: false,
      cssClass: 'small-modal',
      componentProps: {
        title: this.translate.translate('PLAN.DELETE_HEADER'),
        text: this.translate.translate('PLAN.DELETE_MESSAGE'),
        cancelButtonLabel: this.translate.translate('GENERAL.CANCEL'),
        criticalActionButtonLabel: this.translate.translate('GENERAL.DELETE'),
        modalStyle: ModalStyle.Alert,
        icon: 'error',
      },
    })
    await modal.present()
    const { role } = await modal.onDidDismiss()
    if (role === ModalDismissAction.CRITICAL_ACTION) {
      await this.planRepository.deleteWithAllRelated(plan)
      this.planDeleted.emit()
    }
  }

  protected async share(): Promise<void> {
    if (this.plan) {
      await this.efpExportService.showShareDialog(this.plan)
    }
  }
}
